export default {
  // Teals
  brook: '#E5F6F6',
  stream: '#72C9CC',
  creek: '#24A2A6',
  water: '#098B8C',
  ocean: '#005B5E',

  // Greens
  shoot: '#DAEFE6',
  branch: '#75D1A9',
  leaf: '#5DC095',
  bonsai: '#52AD86',
  stem: '#378763',

  // Golds
  ring: '#F7EAD5',
  foil: '#EBC78D',
  medallion: '#E6BC7A',
  gold: '#D2A764',
  crown: '#B08A4D',
  brightyellow: '#FFF8b3',

  // Coppers
  penny: '#F2A291',
  pipe: '#F58D78',
  copper: '#EF6D44',
  wire: '#D1543B',

  // Neutrals
  black: '#000000',
  charcoal: '#2F3034',
  ash: '#4A4B4E',
  smoke: '#666667',
  cloud: '#818181',
  dust: '#9D9C9B',
  stone: '#B8B7B5',
  clay: '#D4D2CE',
  silt: '#E0DEDA',
  sand: '#EFEDE8',
  shell: '#F4F3F0',
  pearl: '#FAF9F7',
  white: '#FFFFFF',
};
